export default "__VITE_ASSET__86b3694f__"